import { gql } from "@apollo/client";

export default gql`
  fragment ComplianceProgramForReportAssessmentGroupSection on AssessmentGroupSectionNode {
    id
    title
    description
    questions {
      edges {
        node {
          id
          question {
            ...ComplianceProgramReportQuestion
          }
        }
      }
    }
  }

  fragment ComplianceProgramForReportAssessmentGroup on AssessmentGroupNode {
    id
    title
    sections {
      edges {
        node {
          ...ComplianceProgramForReportAssessmentGroupSection
        }
      }
    }
  }
`;
